import { Link } from "react-router-dom";
import { Button } from "../ui/button";

interface BannerSectionProps {
  title?: string;
}

export const BannerSection = ({
  title = "Experiência digital completa com suporte e tecnologia em cada etapa",
}: BannerSectionProps) => {
  return (
    <section id="banner" className=" py-10 md:py-24">
      <div className="container">
        <div className="flex flex-col md:p-[80px] p-10 rounded-[20px] items-center justify-center gap-6 bg-n-bg-green">
          <h2
            className="text-4xl md:text-5xl text-n-text-beige max-w-3xl text-center"
            style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
          >
            {title}
          </h2>
          <Link to="/fazer-cotacao">
            <Button>Fazer Cotação</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
